const FALLBACK_TARGET = '/account'

export default defineNuxtRouteMiddleware(({ fullPath, name, query }) => {
  if (import.meta.server) return // fallback if route is not ssr: false in nuxt.config routeRules
  const { isLoggedIn } = useAuth()
  const { navigateToLocalized } = useRouterUtils()

  if (name === 'login' && isLoggedIn.value) {
    const target = decodeRedirectQuery(query) || FALLBACK_TARGET

    return navigateToLocalized(target)
  }

  if (name !== 'login' && !isLoggedIn.value) {
    return navigateToLocalized(createRedirectLocation({ name: 'login' }, fullPath))
  }
})
